import React, { useState, useEffect } from "react";
import { colorOptions, TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { ISkuVariant, TSku } from "models/inventory/interfaces/sku.interface";
import { Typography } from "design_system/src";
import styles from "./DetailTags.module.scss";

interface DetailTagsProps {
  vehicle?: TVehicle;
  sku?: TSku;
  skuVariant?: ISkuVariant;
}

const DetailTags = ({vehicle, sku, skuVariant}: DetailTagsProps) => {
  const [tags, setTags] = useState<String[]>([]);
  const [variantTags, setVariantTags] = useState<String[]>([]);

  useEffect(() => {
    if (vehicle) {
      setTags([
        vehicle.year.toString(),
        `${vehicle.cylindersCapacity} CC`,
        `${vehicle.mileage} Km`
      ]);
    } else if (sku) {
      setTags([
        sku.year.toString(),
        `${sku.cc} CC`,
      ]);

      const colorLabel = skuVariant?.color
        ? colorOptions.find((c) => c.value === skuVariant?.color)?.label ?? skuVariant?.color
        : null;
      const skuVariantParts = [colorLabel ?? "", skuVariant?.hasGps ? "Con GPS" : ""].filter(Boolean);
      setVariantTags(skuVariantParts.length > 0 ? skuVariantParts : []);
    }
  }, [vehicle, sku, skuVariant]);

  return (
    <div className="display_flex flex_gap_xxs flex_wrap">
      {tags.map((tag, index) => {
        return (
          <Typography
            scale="xsmall"
            weight="600"
            className={styles.tag}
            key={`vehicle-detail-${index}`}
          >
            {tag}
          </Typography>
        );
      })}

      {vehicle?.maintenanceDays === 0 && <Typography
        scale="xsmall"
        weight="600"
        className={`${styles.tag} ${styles["tag--dark"]}`}
      >
        Entrega inmediata
      </Typography>}

      {variantTags.map((tag, index) => {
        return (
          <Typography
            scale="xsmall"
            weight="600"
            className={`${styles.tag} ${styles["tag--dark"]}`}
            key={`vehicle-detail-${index}`}
          >
            {tag}
          </Typography>
        );
      })}
    </div>
  );
};

export default DetailTags;
